/** The invitation link of «Crear tu cuenta»: its path, its token and the port it claims through (the screen itself loads
 * apart from the Panel's entry, `claim-account.tsx`). */
/** Public invitation claim: the backend answers identically for valid, invalid, expired and replayed tokens. */
export interface ClaimAccountPort {
  readonly claim: (token: string, password: string) => Promise<void>;
  readonly recover: (email: string) => Promise<void>;
}

export const CLAIM_ACCOUNT_PATH = '/claim-account';

/** Reads `#token=…` from the invitation link; the token never travels in the path or query. */
export function readInvitationToken(hash: string): string {
  return new URLSearchParams(hash.replace(/^#/, '')).get('token') ?? '';
}

